import LinkIcon from '@mui/icons-material/Link';
import { Alert, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { CustomerURLInformation, Display, MapURLInformation } from 'adoms-common-lib';
import React from 'react';


type CustomerURLInformationListTableProps = {
    customerURLInformationList: CustomerURLInformation[]
    setSnackBarOpen: React.Dispatch<React.SetStateAction<boolean>>
};

/**
 * 配送依頼用URL情報リストテーブル表示用コンポーネント
 * MapURLInformation側SaaS対応完了次第相手方と統合する
 * @param props:参照用プロパティ
 */
export const CustomerURLInformationListTable: React.FC<CustomerURLInformationListTableProps> = (props) => {

    /**
     * TableBodyを表示する
     * @param customerURLInformationURLInfo 
     * @returns 
     */
    const displayTableBody = (customerURLInformationURLInfo: CustomerURLInformation) => {
        const createDateTime = Display.getDateTimeStringFromISO8601(customerURLInformationURLInfo.createDateTime);
        const expirationDateTime = Display.getDateTimeStringFromISO8601(customerURLInformationURLInfo.expirationDateTime);
        const handleCopyToClipboard = async () => {
            if (customerURLInformationURLInfo.url) {
                await global.navigator.clipboard.writeText(customerURLInformationURLInfo.url);
                props.setSnackBarOpen(true);
            }
        };

        return (
            <TableRow key={customerURLInformationURLInfo.url}>
                <TableCell>
                    <Tooltip title="URLをコピー">
                        <IconButton
                            aria-label="close"
                            color="primary"
                            size="small"
                            onClick={
                                () => handleCopyToClipboard()
                            }
                        >
                            <LinkIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </TableCell>
                <TableCell>
                    {customerURLInformationURLInfo.urlId}
                </TableCell>
                <TableCell>{expirationDateTime}</TableCell>
                <TableCell>{createDateTime}</TableCell>
                <TableCell>{customerURLInformationURLInfo.issueUser.name}</TableCell>
                <TableCell>{customerURLInformationURLInfo.businessPartnerId}</TableCell>
                <TableCell>{customerURLInformationURLInfo.remarks}</TableCell>
            </TableRow>
        );
    };
    return (
        <Table sx={{ minWidth: 650 }} aria-label="customer-credential-url-info-table">
            <TableHead>
                <TableRow>
                    <TableCell >
                        <LinkIcon sx={{ marginLeft: "5px", marginTop: "6px" }} fontSize="small" />
                    </TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>有効期限</TableCell>
                    <TableCell>発行日時</TableCell>
                    <TableCell>発行者</TableCell>
                    <TableCell>ビジネスパートナーID</TableCell>
                    <TableCell>備考</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    props.customerURLInformationList.length !== 0 ?
                        props.customerURLInformationList.map((customerURLInformationURLInfo, i) => (
                            displayTableBody(customerURLInformationURLInfo)
                        ))
                        :
                        <TableRow>
                            <TableCell colSpan={6}>
                                <Alert severity="info">URLがありません。</Alert>
                            </TableCell>
                        </TableRow>
                }
            </TableBody>
        </Table>
    );
};